import { Box, Modal, Typography, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import { Trash2, PenLine, Plus } from "lucide-react";
import "./CustomizableModal.scss";
import { useEffect, useState } from "react";

interface CustomizableModalProps {
  isOpen: boolean;
  nextButton: string;
  modalType: string;
  panelView: string;
  cancel: () => void;
  save?: (value?: string, selectedUnit?: number) => void;
  initialValue?: string;
  selectedUnitId?: number;
  options?: any;
}

interface Operation {
  [key: string]: string;
}

interface Unit {
  label: string;
  value: number;
}

interface Content {
  [key: string]: string;
}

export default function CustomizableModal({
  isOpen,
  nextButton,
  cancel,
  save,
  modalType,
  panelView,
  initialValue,
  options,
}: CustomizableModalProps) {
  const [inputValue, setInputValue] = useState("");
  const [existingData, setExistingData] = useState<any[]>([]);

  const operationMap: Operation = {
    add: "Añadir",
    addArea: "Añadir",
    edit: "Editar",
    editArea: "Editar",
    delete: "Eliminar",
  };

  const contentMap: Content = {
    category: "Categoría",
    area: "Área",
    unit: "Unidad",
  };

  function generateModalTitle(modalType: string, panelView: string) {
    const operationLabel = operationMap[modalType] || "Operación de";
    const contentLabel = contentMap[panelView] || "Contenido";
    return `${operationLabel} ${contentLabel}`;
  }

  useEffect(() => {
    setExistingData(options);
  }, [options]);

  useEffect(() => {
    if (modalType === "edit" && isOpen) {
      setInputValue(initialValue || "");
    }
  }, [modalType, isOpen, initialValue]);

  return (
    <Modal open={isOpen}>
      <Box
        className={
          modalType === "delete" ? "custom-modal delete-modal" : "custom-modal"
        }
      >
        <Box className={"custom-modal__header"}>
          <Box className="custom-modal__header__container">
            <Box className="custom-modal__header__container__icon">
              {modalType === "add" && <Plus />}
              {modalType === "edit" && <PenLine />}
              {modalType === "delete" && <Trash2 />}
            </Box>
            <Box className="custom-modal__header__container__texts">
              <Typography className="custom-modal__header__container__texts-title">
                {generateModalTitle(modalType, panelView)}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className="custom-modal__content">
          {modalType === "delete" ? (
            <Typography className="custom-modal__content__message delete-modal__content__message">
              ¿Seguro que desea eliminar los registros seleccionados?
            </Typography>
          ) : (
            <>
              <Typography>{`Nombre de la ${contentMap[panelView]}`}</Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                value={inputValue}
                autoComplete="off"
                onChange={(e) => setInputValue(e.target.value)}
              />
            </>
          )}
        </Box>
        <Box
          className={
            modalType === "delete"
              ? "custom-modal__buttons delete-modal__buttons"
              : "custom-modal__buttons right-orientation"
          }
        >
          <Button
            className="custom-modal__buttons-cancel"
            onClick={cancel}
            disableRipple
          >
            <Typography>Cancelar</Typography>
          </Button>
          <Button
            className="custom-modal__buttons-save"
            disabled={
              modalType !== "delete" &&
              (!inputValue.trim() || (existingData || []).includes(inputValue))
            }
            onClick={() => {
              if (save !== undefined) {
                save(inputValue);
              }
            }}
            disableRipple
          >
            <Typography>{nextButton}</Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
